import { Box, Checkbox, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import { DropdownFilterContainer, StyledMenuItem, StyledSelect } from "./Atom"
import { useState } from "react"

const ProvidersHeaderGeneralDropdownFilter = (props: any) => {
  const {
    id,
    disabled,
    handleFilter,
    placeholder,
    value,
    filterData,
    headerLabel,
  } = props

  const [checkedMenuItems, setCheckedMenuItems] = useState<Array<number>>([])

  const handleCheckedMenuItems = (index: any) => {
    if (checkedMenuItems.includes(index)) {
      setCheckedMenuItems(
        checkedMenuItems.filter((item: any) => item !== index),
      )
    } else {
      setCheckedMenuItems([...checkedMenuItems, index])
    }
  }

  return (
    <DropdownFilterContainer>
      <Typography fontSize={10}>{headerLabel}</Typography>

      <StyledSelect
        labelId="demo-multiple-name-label"
        id={`filter-${id}`}
        value={value}
        onChange={handleFilter}
        disabled={disabled}
        IconComponent={ExpandMoreIcon}
        displayEmpty
        renderValue={(selected: any): any => {
          return value ? `${value?.label}` : `${placeholder}`
        }}
      >
        {filterData?.length ? (
          filterData?.map((item: any, index: number) => (
            <StyledMenuItem key={`${item?.label}-${id}-${index}`} value={item}>
              {item?.label}
            </StyledMenuItem>
          ))
        ) : (
          <StyledMenuItem disabled={true}>No Data</StyledMenuItem>
        )}
      </StyledSelect>
    </DropdownFilterContainer>
  )
}

export default ProvidersHeaderGeneralDropdownFilter
